import * as React from "react";
import { IconProps } from "./IconProps";

export const IconCircleCheckmark = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99992 2.66671C5.0544 2.66671 2.66659 5.05452 2.66659 8.00004C2.66659 10.9456 5.0544 13.3334 7.99992 13.3334C10.9454 13.3334 13.3333 10.9456 13.3333 8.00004C13.3333 5.05452 10.9454 2.66671 7.99992 2.66671ZM1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004ZM10.4221 5.8174C10.707 6.05055 10.749 6.47057 10.5159 6.75553L7.51589 10.4222C7.39662 10.568 7.22125 10.6565 7.03313 10.6659C6.84501 10.6753 6.6617 10.6046 6.52851 10.4714L5.19518 9.13811C4.93483 8.87776 4.93483 8.45565 5.19518 8.1953C5.45553 7.93495 5.87764 7.93495 6.13799 8.1953L6.95043 9.00774L9.48395 5.91122C9.7171 5.62625 10.1371 5.58425 10.4221 5.8174Z"
          fill={color}
        />
      </svg>
    );
  },
);
